import { gql } from '@apollo/client'

export const CHART5_QUERY = gql`
  query processingsFeedbackQuote(
    $groupBy: ProcessingsFeedbackQuoteGroupBy
    $filter: ProcessingFeedbackQuoteFilter
  ) {
    processingsFeedbackQuote(groupBy: $groupBy, filter: $filter) {
      series {
        color
        title
        total
        average
        stack
        serie {
          name
          count
          total
          percentage
        }
      }
    }
  }
`
